
import "./Common_History_Vendor.css";
import React, { useState } from "react";
import Common_Rate_Btn from "../common-rate-btn/Common_Rate_Btn";
import History_Vendor_Rate_Btn_Modal from "../../header/history/history-vendor/history-vendor-rate-btn-modal/History_Vendor_Rate_Btn_Modal";

const Common_History_Vendor = ({ data }) => {

    const [showRateModal, setShowRateModal] = useState(false);

    if (!data) return null;

    const handleOpenModal = () => setShowRateModal(true);
    const handleCloseModal = () => setShowRateModal(false);

    return (
        <div className="history-vendor-card">
            <div className="history-vendor-header-bar">
                Details ID: {data.detailsId || "#ORD00000"}
            </div>

            <div className="history-vendor-content">
                <div className="history-vendor-thumb">
                    <img
                        src={data.image}
                        alt={data.vendor}
                        className="thumb-img"
                    />
                </div>
                <div className="history-vendor-body">
                    <div className="history-info-row">
                        <span className="info-label">Vendor:</span>
                        <span className="info-value ">{data.vendor}</span>
                    </div>
                    <div className="history-info-row">
                        <span className="info-label">Date:</span>
                        <span className="info-value">{data.date}</span>
                    </div>
                    <div className="history-info-row">
                        <span className="info-label">Time:</span>
                        <span className="info-value">{data.time}</span>
                    </div>
                </div>
            </div>
            <Common_Rate_Btn onBtnClick={handleOpenModal} />
            <History_Vendor_Rate_Btn_Modal
                show={showRateModal}
                handleClose={handleCloseModal}
                expertName={data.vendor}
            />
        </div>
    );
};

export default Common_History_Vendor;